<template>
  <div>
    <b-modal :active="isTranslationsModalVisible" :can-cancel="true" @close="closeTranslationsModal">
      <div class="has-background-white-ter p-4">
        <h3 class="is-size-5 has-text-weight-semibold mb-4">
          {{ descriptionForm.id ? "Редактировать перевод" : "Добавить перевод" }}
        </h3>
        <form @submit.prevent="saveDescription">
          <div class="columns is-multiline">
            <div class="column is-one-quarter">
              <b-field
                label="Язык"
                :type="descriptionErrors.lang_code ? 'is-danger' : ''"
                :message="descriptionErrors.lang_code && descriptionErrors.lang_code[0] || ''"
              >
                <b-select v-model="descriptionForm.lang_code" expanded>
                  <option v-for="lang in supportedLangs" :key="lang" :value="lang">{{ lang }}</option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-three-quarters">
              <b-field
                label="Название"
                :type="descriptionErrors.name ? 'is-danger' : ''"
                :message="descriptionErrors.name && descriptionErrors.name[0] || ''"
              >
                <b-input v-model="descriptionForm.name" maxlength="255" />
              </b-field>
            </div>
            <div class="column is-full">
              <b-field
                label="Описание"
                :type="descriptionErrors.description ? 'is-danger' : ''"
                :message="descriptionErrors.description && descriptionErrors.description[0] || ''"
              >
                <b-input v-model="descriptionForm.description" type="textarea" />
              </b-field>
            </div>
            <div class="column is-full is-flex is-justify-content-end">
              <b-button class="mr-2" :disabled="isDescriptionSaving" @click="closeTranslationsModal">Отмена</b-button>
              <b-button type="is-info" native-type="submit" :loading="isDescriptionSaving">
                {{ descriptionForm.id ? "Сохранить" : "Добавить" }}
              </b-button>
            </div>
          </div>
        </form>
      </div>
    </b-modal>

    <b-tabs v-model="activeTab" type="is-boxed">
      <b-tab-item label="Завод">
        <div class="is-flex">
          <b-loading
            :active="isLoading"
          />
          <div v-if="!isLoading">
            <div v-if="FactoryData.branch" class="has-background-white px-4 py-4 mr-5 main-inner-set">
              <div class="mb-3">
                <p class="is-uppercase heading-text-size has-text-grey has-text-weight-medium mb-3">Редактировать Завод</p>
                <small>Введите данные</small>
              </div>

              <b-field label="Компания">
                <b-select
                  placeholder="Выберите компанию"
                  v-model="FactoryData.branch.company.id"
                  required
                >
                  <option
                    v-for="option of Company_list"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>

              <b-field
                label="Филиал"
                class="mt-3"
              >
                <b-select
                  placeholder="Выберите филиал"
                  v-model="FactoryData.branch.id"
                  required
                >
                  <option
                    v-for="option of CompanyBranches"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>

              <label>
                <b>Наименование завода</b>
              </label>
              <input
                class="input"
                type="text"
                placeholder="Наименование завода"
                v-model="FactoryData.name"
                required
              >
              <b-field label="Телеграм канал" class="mt-4">
                <b-input
                  type="text"
                  v-model.trim="FactoryData.telegram_chanel"
                  placeholder="ID телеграм канала"
                  required
                />
              </b-field>
              <div class="mt-3">
                <button
                  class="button is-info"
                  @click="SaveChangesFac"
                >Сохранить
                </button>
                <button class="button is-warning mx-3">Деактивировать</button>
                <button
                  class="button is-danger"
                  @click="DeleteFactory"
                >Удалить
                </button>
              </div>
            </div>
          </div>

          <div class="has-background-white px-4 py-4 main-inner-set">
            <h4 class="heading is-size-6 has-text-weight-medium">СПИСОК CMS</h4>
            <ul
              v-for="item of CmsData"
              :key="item.id"
              class="list ml-5"
            >
              <li>
                <a @click="EditCms(item.id)">{{ item.name }}</a>
              </li>
            </ul>
            <router-link
              class="has-text-weight-medium"
              to="/cms-registration"
            >Зарегистрировать CMS
            </router-link>
          </div>
        </div>
      </b-tab-item>

      <b-tab-item label="Переводы">
        <div class="has-background-white px-4 py-4">
          <div class="is-flex is-justify-content-space-between is-align-items-center mb-4">
            <h4 class="is-size-6 has-text-weight-medium">Переводы завода</h4>
            <b-button type="is-info" @click="openCreateDescriptionModal">Добавить</b-button>
          </div>
          <b-table
            :data="descriptions"
            :loading="isTranslationsLoading"
            hoverable
            striped
            @cellclick="openEditDescriptionModal"
          >
            <b-table-column field="id" label="ID" width="40" numeric v-slot="props">
              {{ props.row.id }}
            </b-table-column>
            <b-table-column field="lang_code" label="Язык" v-slot="props">
              {{ props.row.lang_code }}
            </b-table-column>
            <b-table-column field="name" label="Название" v-slot="props">
              {{ props.row.name || '-' }}
            </b-table-column>
            <b-table-column field="description" label="Описание" v-slot="props">
              {{ props.row.description || '-' }}
            </b-table-column>
            <b-table-column label="Удалить" centered v-slot="props">
              <b-button
                type="is-danger is-light"
                size="is-small"
                icon-right="trash"
                @click.stop="deleteDescription(props.row.id)"
              />
            </b-table-column>
          </b-table>
          <section v-if="descriptionsTotal > descriptionsPerPage" class="mt-4">
            <b-pagination
              :total="descriptionsTotal"
              :per-page="descriptionsPerPage"
              order="is-centered"
              icon-pack="fas"
              :current="descriptionsPage"
              class="base-table__pagination"
              @change="fetchDescriptions"
            />
          </section>
        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>


<script>
export default {
  data() {
    return {
      isLoading: true,
      FactoryData: [],
      Company_list: [],
      factory_id: null,
      selected_company: null,
      CompanyBranches: [],
      selected_branch: null,
      CmsData: [],
      factory_name: null,
      activeTab: 0,
      isTranslationsModalVisible: false,
      isTranslationsLoading: false,
      isDescriptionSaving: false,
      descriptions: [],
      descriptionsTotal: 0,
      descriptionsPage: 1,
      descriptionsPerPage: 10,
      supportedLangs: ["ru", "kk", "en"],
      descriptionForm: {
        id: null,
        lang_code: "ru",
        name: "",
        description: "",
      },
      descriptionErrors: {},
    };
  },
  watch: {
    "FactoryData.branch.company.id"(newValue) {
      this.getCompanyBranches(newValue);
    },
    activeTab(val) {
      if (val === 1) this.fetchDescriptions(this.descriptionsPage);
    },
  },
  created() {
    this.factory_id = this.$router.history.current.params.id.replace(/[^0-9]/g, "");
    this.getCompanies();
    this.getFactoryData();
    this.GetCmsList();
  },
  methods: {
    async getFactoryData(e) {
      this.isLoading = true;
      if (e) {
        this.factory_id = e;
      }

      await this.$axios.get(`admin/factories/${this.factory_id}`).then(response => {
        this.FactoryData = response.data.data;
        this.getCompanyBranches(this.FactoryData.branch.company.id);
      });
      this.isLoading = false
    },


    async getCompanies() {
      await this.$axios.get(`admin/companies`).then(response => {
        this.Company_list = response.data.data;
      });
    },
    async getCompanyBranches(e) {
      await this.$axios.get(`admin/companies/${e}/branches`).then(response => {
        this.CompanyBranches = response.data.data;
      });
    },
    async DeleteFactory() {
      await this.$axios.delete(`admin/factories/${this.factory_id}`).then(() => {
        this.$router.push("/factory-list");
      });
    },
    async SaveChangesFac() {
      let data = {
        "name": this.FactoryData.name,
        "branch_id": this.FactoryData.branch.id,
        "telegram_chanel": this.FactoryData.telegram_chanel,
      };

      await this.$axios.put(`admin/factories/${this.factory_id}`, data).then(() => {
        this.$router.push("/factory-list");
      });
    },
    async GetCmsList() {
      await this.$axios.get(`admin/factories/${this.factory_id}/agents`).then(response => {
        this.CmsData = response.data.data.agents;
      });
    },
    EditCms(e) {
      this.$router.push(`/cms-editor/${e}`);
    },
    openCreateDescriptionModal() {
      this.resetDescriptionForm();
      this.isTranslationsModalVisible = true;
    },
    openEditDescriptionModal(item) {
      this.descriptionErrors = {};
      this.descriptionForm = {
        id: item.id,
        lang_code: item.lang_code || "ru",
        name: item.name || "",
        description: item.description || "",
      };
      this.isTranslationsModalVisible = true;
    },
    closeTranslationsModal() {
      this.isTranslationsModalVisible = false;
      this.resetDescriptionForm();
    },
    resetDescriptionForm() {
      this.descriptionErrors = {};
      this.descriptionForm = {
        id: null,
        lang_code: "ru",
        name: "",
        description: "",
      };
    },
    async fetchDescriptions(page = 1) {
      this.descriptionsPage = page || 1;
      this.isTranslationsLoading = true;
      try {
        const { data } = await this.$axios.get(
          `admin/factory-descriptions?factory_id=${this.factory_id}`
        );
        this.descriptions = data?.data || [];
        this.descriptionsTotal = data?.count || 0;
      } catch (e) {
        throw new Error(e);
      } finally {
        this.isTranslationsLoading = false;
      }
    },
    async saveDescription() {
      this.descriptionErrors = {};
      this.isDescriptionSaving = true;
      const payload = {
        factory_id: this.factory_id,
        lang_code: this.descriptionForm.lang_code,
        name: this.descriptionForm.name || null,
        description: this.descriptionForm.description || null,
      };
      try {
        if (this.descriptionForm.id) {
          await this.$axios.put(`admin/factory-descriptions/${this.descriptionForm.id}`, payload);
        } else {
          await this.$axios.post("admin/factory-descriptions", payload);
        }
        await this.fetchDescriptions(this.descriptionsPage);
        this.closeTranslationsModal();
      } catch (e) {
        this.descriptionErrors = e.error?.response?.data?.errors ?? {};
        throw e;
      } finally {
        this.isDescriptionSaving = false;
      }
    },
    async deleteDescription(id) {
      await this.$axios.delete(`admin/factory-descriptions/${id}`);
      await this.fetchDescriptions(this.descriptionsPage);
      if (this.descriptionForm.id === id) this.resetDescriptionForm();
    },

  },
};
</script>

<style scoped>
.main-inner-set {
  flex: 1;
}

.list {
  list-style: disc;
}
</style>
